import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button, Tooltip } from '@salesforce/design-system-react';

import './TruncatedList.scss';

class TruncatedList extends Component {
  render() {
    return (
      <Tooltip
        align="left"
        width="100px"
        content={this.props.list.map(index => (
          <dt key={`${index}-tag`}>
            <span>{index}</span>
          </dt>
        ))}
        dialogClassName="truncated-list"
        position="overflowBoundaryElement"
      >
        <Button
          label={`${this.props.list[0]}... (${this.props.list.length})`}
          variant="base"
          className="truncated-list-button"
        />
      </Tooltip>
    );
  }
}

TruncatedList.propTypes = {
  list: PropTypes.array
};

export default injectIntl(TruncatedList);
